const Card = ({children}) => {

  return (
    <div className="back">
      {children}
    </div>
  )
}

export default Card